import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import '../../interfaceSettings.css';
import GwinnettLogo from '../../assets/webp/ggc-light-logo.webp';
import { Navbar, Container, Nav, Offcanvas, NavDropdown, Badge } from 'react-bootstrap';
import { logout } from '../../actions/auth';

const UserNavbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logout());
    };

    const handleDropdownClick = (e) => {
        e.stopPropagation();
    };

    return (
        <Navbar expand="lg" className="navbar-custom mb-3">
            <Container fluid>
                {}

                <Navbar.Brand as={Link} to="/userHome" className="d-flex align-items-center">
                    <img src={GwinnettLogo} alt="Gwinnett Logo" className="logo me-2" />
                    <span className="heading-gradient">WALKING TRAILS</span>
                </Navbar.Brand>

                <div className="d-none d-lg-flex align-items-center me-3">
                    <Badge
                        bg=""
                        style={{
                            backgroundColor: '#6c757d', // gray tone 🔹
                            color: '#ffffff',
                            fontSize: '0.75rem',
                        }}
                    >
                        Role: User
                    </Badge>
                </div>

                <Navbar.Toggle
                    aria-controls="offcanvas-navbar"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="d-lg-none"
                />

                <Navbar.Offcanvas
                    id="offcanvas-navbar"
                    placement="end"
                    show={isMenuOpen}
                    onHide={() => setIsMenuOpen(false)}
                    className="d-lg-none"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Menu</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            <Nav.Link as={Link} to="/userHome" onClick={() => setIsMenuOpen(false)}>
                                Home
                            </Nav.Link>
                            <Nav.Link as={Link} to="/trails" onClick={() => setIsMenuOpen(false)}>
                                Trails
                            </Nav.Link>
                            <NavDropdown title="Videos" id="offcanvas-exercises" onClick={handleDropdownClick} aria-label="Videos menu dropdown">
                                <NavDropdown.Item as={Link} to="/bodyWeightExercises" onClick={() => setIsMenuOpen(false)}>Body Weight Exercises</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/properWalkingTechniques" onClick={() => setIsMenuOpen(false)}>Proper Walking Techniques</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/stretchesForWalking" onClick={() => setIsMenuOpen(false)}>Stretches For Walking</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/nutritionandHydration" onClick={() => setIsMenuOpen(false)}>Nutrition and Hydration</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/injuryPrevention" onClick={() => setIsMenuOpen(false)}>Injury Prevention</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link as={Link} to="/userControlPanel" onClick={() => setIsMenuOpen(false)}>
                                My Profile
                            </Nav.Link>
                            <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                        </Nav>

                        <div className="mt-3">
                            <Badge
                                bg=""
                                style={{
                                    backgroundColor: '#6c757d', // gray tone 🔹
                                    color: '#ffffff',
                                    fontSize: '0.75rem',
                                }}
                            >
                                Role: User
                            </Badge>
                        </div>

                    </Offcanvas.Body>
                </Navbar.Offcanvas>

                <Navbar.Collapse id="navbarNav" className="d-none d-lg-flex">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="/userHome">Home</Nav.Link>
                        <Nav.Link as={Link} to="/trails">Trails</Nav.Link>
                        <NavDropdown title="Videos" id="navbar-exercises" aria-label="Videos menu dropdown">
                            <NavDropdown.Item as={Link} to="/bodyWeightExercises">Body Weight Exercises</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/properWalkingTechniques">Proper Walking Techniques</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/stretchesForWalking">Stretches For Walking</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/nutritionandHydration">Nutrition and Hydration</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/injuryPrevention">Injury Prevention</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link as={Link} to="/userControlPanel">My Profile</Nav.Link>
                        <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default UserNavbar;
